import * as toast from 'smg/toast';

if (document.body.id === 'alerts-toasts') {
    const dangerBtn = document.querySelector<HTMLButtonElement>('#toast-danger');
    const primaryBtn = document.querySelector<HTMLButtonElement>('#toast-primary');
    const infoBtn = document.querySelector<HTMLButtonElement>('#toast-info');
    const successBtn = document.querySelector<HTMLButtonElement>('#toast-success');
    const warningBtn = document.querySelector<HTMLButtonElement>('#toast-warning');

    dangerBtn?.addEventListener('click', () => toast.Error('Danger'));
    primaryBtn?.addEventListener('click', () => toast.Show('Primary'));
    infoBtn?.addEventListener('click', () => toast.Show('Info', ['bg-info']));
    successBtn?.addEventListener('click', () => toast.Success('Success'));
    warningBtn?.addEventListener('click', () => toast.Show('Warning', ['bg-warning']));
}
